<template>
  <v-autocomplete
    v-model="selected"
    :items="items"
    :label="label"
    :search-input.sync="search"
    :error="error"
    clearable
    hide-details
  >
  </v-autocomplete>
</template>

<script>
import {generateFilterObjectDef} from '@portal/qlik'

export default {
  name: 'QlikCustomSelector',
  props: {
    value: {type: String, required: false},
    label: {type: String, required: false},
    qAppId: {type: String, required: true},
    qDimensionId: {type: String, required: true},
    error: {type: Boolean, required: false}
  },
  data: () => ({
    filterObject: null,
    search: '',
    items: [],
  }),
  computed: {
    selected: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  watch: {
    async search (value) {
      if(value) {
        await this.filterObject?.searchListObjectFor({qPath: '/qListObjectDef', qMatch: '*' + value + '*'}) 
      } else {
        await this.filterObject?.abortListObjectSearch({qPath: '/qListObjectDef'})
      }
    },
    qDimensionId: {
      immediate: true,
      handler: function () {
        this.init()
      }
    }
  },
  methods: {
    async init () {
      if (this.filterObject) {
        await this.$qlik[this.qAppId].enigmaDoc.destroySessionObject(this.filterObject.id)
      }
      const def = generateFilterObjectDef(this.qDimensionId)
      this.filterObject = await this.$qlik[this.qAppId].enigmaDoc.createSessionObject(def)
      await this.fetchData()
      this.filterObject.on('changed', this.fetchData)

      // Allow to be sure the initial value is present in the item list
      if (this.value) this.search = this.value
    },
    async fetchData () {
      const layout = await this.filterObject.getLayout()
      if (!layout.qListObject.qDataPages.length) {
        this.items = []
        return
      }
      this.items = layout.qListObject.qDataPages[0].qMatrix.map(item => ({
        id: item[0].qElemNumber,
        text: item[0].qText,
        value: item[0].qText.substring( item[0].qText.indexOf( '(' ) + 1, item[0].qText.indexOf( ')' ) ),
        selected: item[0].qState === 'S',
        state: item[0].qState,
        disabled: item[0].qState === 'X'
      }))
    },
  },
  beforeDestroy () {
    this.$qlik[this.qAppId].enigmaDoc.destroySessionObject(this.filterObject.id)
  }
}
</script>